import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const ViewCareteamMemberGroup = ({provider}) => {
    const navigate = useNavigate()
  return (
    <div
        key={provider._id}
      className="d-flex flex-column justify-content-center my-2 align-items-start cursor-pointer"
      style={{
        height: "auto",
        width: "100%",
        //   backgroundColor: "rgba(227, 236, 237, 1)",
      }}
    >
      <div
        className="d-flex justify-content-between align-items-start p-1"
        style={{
          height: "auto",
          width: "100%",
          //   backgroundColor: "rgba(227, 236, 237, 1)",
        }}
      >
        <div className="d-flex align-content-center w-75">
          <img
            src={
              provider.profilePicture
                ? provider.profilePicture
                : "images/avatar.png"
            }
            alt=""
            className=" object-fit-cover me-2"
            style={{ height: "50px", width: "50px", borderRadius: "50%" }}
          />
          <div className="flex flex-column justify-content-center ">
            <h3 style={{ fontSize: "16px" }}>{provider.full_name}</h3>
            <p style={{ fontSize: "12px" }}>{provider._id}</p>
          </div>
        </div>
        <div onClick={() => navigate("/myprofile", { state: provider })}>
          <span style={{ fontSize: "12px" }}>
            {" "}
            <span
              className="text-decoration-none"
              style={{ color: "rgba(175, 177, 178, 1)" }}
            >
              View profile{" "}
              <span style={{ color: "rgba(21, 101, 99, 1)" }}>
                <FiArrowRight size={"12px"} />
              </span>
            </span>{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ViewCareteamMemberGroup;
